import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=2c82e65e&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c82e65e')) {
      api.createRecord('2c82e65e', component.options)
    } else {
      api.reload('2c82e65e', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=2c82e65e&", function () {
      api.rerender('2c82e65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/reserve_system_dashboard/components/BarChart.vue"
export default component.exports